<div class="kt-portlet container">
	<div class="kt-portlet__head">
		<div class="encabezado mt-3">
			<h1 class="titulo"><i class="fas fa-satellite"></i>&nbsp;{{titulo}}</h1>
		</div>
		<div class="mt-3">
			<kt-boton-exportar-tabla [tipoBoton]="'grid'" [nombreArchivo]="'Vehiculos_sin_transmitir'"
				[datos]="datosReporte" [buttonDisabled]="isDisabled">
			</kt-boton-exportar-tabla>
		</div>
	</div>
	<div class="kt-portlet__body">
		<form [formGroup]="busquedaForm">
			<div class="row">
				<div class="col-md-3 form-group">
					<i class="fas fa-calendar-week"></i>&nbsp;
					<label>Dias sin Transmitir</label>
					<input matInput formControlName="cantidadDias" class="form-control">
				</div>
				<div class="form__actions col-md-6 mt-3" style="text-align: center;">
					<button id="agregarBoton" mat-raised-button class="mt-3  btn btn-success"
						(click)="obtenerListaSinTransmitir()" style="margin-right: 15px;"><i
							class="fas fa-search"></i>&nbsp;Buscar</button>&nbsp;
					<button mat-raised-button (click)="regresar()"><i class="fas fa-times"></i>&nbsp;Cancelar</button>

				</div>
			</div>
		</form>
		<mat-divider></mat-divider>
		<div class="kt-section mt-3">
			<div class="kt-section__content">
				<div class="contenedor-modal">
					<div class="data-grid" *ngIf="listaSinTransmitir.length">
						<dx-data-grid id="gridContainer" [columnHidingEnabled]="true" [dataSource]="listaSinTransmitir"
							[showBorders]="true" [rowAlternationEnabled]="true">
							<dxo-paging [pageSize]="7"></dxo-paging>
							<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[7, 10, 50, 100]"
								[showInfo]="true">
							</dxo-pager>
							<dxo-group-panel [emptyPanelText]="mensajeAgrupar" [visible]="true"></dxo-group-panel>
							<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
							<dxi-column dataField="imei" caption="IMEI" alignment="center" [width]="200">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="economico" caption="Económico" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="placas" caption="Placas" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="nombreCliente" caption="Cliente" alignment="center" [width]="300">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="estado" caption="Estado" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="fechaHora" caption="Fecha y Hora" alignment="center" [width]="200">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="diasSinTransmitir" caption="Tiempo sin transmitir"
								alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="lat" caption="Latitud" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="lng" caption="Longitud" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="velocidad" caption="Velocidad" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="marca" caption="Marca" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="modelo" caption="Modelo" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
						</dx-data-grid>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>
